import { render, staticRenderFns } from "./ParchmentDash.vue?vue&type=template&id=62c67f72"
import script from "./ParchmentDash.vue?vue&type=script&lang=js"
export * from "./ParchmentDash.vue?vue&type=script&lang=js"
import style0 from "./ParchmentDash.vue?vue&type=style&index=0&id=62c67f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports